import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ImageBackground } from '~/assets/images';
import { breakpoints } from '~/styles/tools/breakpoints';

export const BackgroundContainer = styled.div`
  background: url(${ImageBackground}) 0% / cover fixed,
    ${({ theme }) => theme.colors.background};
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 80rem;

  > svg {
    width: 196.33px;
  }

  > form {
    width: 100%;
  }

  @media (max-width: ${breakpoints.medium}) {
    max-width: 45.3rem;
  }
`;

export const Title = styled.h1`
  font-size: 3.8rem;
  color: ${({ theme }) => theme.colors.yellow};
  margin: 2.181rem 0 2.2rem 0;
  @media (max-width: ${breakpoints.medium}) {
    font-size: 2rem;
  }
`;

export const RememberMeLink = styled(Link)`
  color: #fff;
  font-size: 1.7rem;
`;

export const CheckBox = styled.input`
  margin: 0.5rem 0.5rem 0 0;
`;

export const RememberMeText = styled.label`
  color: #fff;
  font-size: 1.7rem;
`;

export const RememberMeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2.2rem 0 3.5rem 0;
  width: 100%;
`;
